import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import Validator from 'validatorjs'

import request from 'utils/request'
import BaseComponent from 'utils/BaseComponent'
import { retrieveUser, login } from 'utils/auth'

import Input from 'components/Input'
import Button from 'components/Button'

import { statusChanged } from 'components/RequestStatus/actions'

import { UPDATE_USER_PASSWORD_URL } from 'constants'

import './index.scss'

export class EditPassword extends BaseComponent {
  static validationRules = {
    current_password: 'string|required|min:8',
    password: 'string|required|min:8',
    password_confirmation: 'string|required|min:8|same:password'
  }

  constructor(props) {
    super(props)

    this._bind('_handleChange', '_handleSubmit', '_validate')

    this.state = {
      userId: '',
      buttonProps: {
        disabled: true
      },
      formData: {
        current_password: '',
        password: '',
        password_confirmation: ''
      },
      errors: {
        current_password: [],
        password: [],
        password_confirmation: []
      }
    }
  }

  componentDidMount() {
    this.setState({
      userId: retrieveUser().uuid
    })
  }


  _handleSubmit(e) {
    e.preventDefault()

    this.props.updateRequestStatus('progress', 'Actualizando datos...')

    const userId = this.state.userId
    request(UPDATE_USER_PASSWORD_URL(userId), {
      method: 'PUT',
      body: { ...this.state.formData }
    })
    .then((res) => {
      login(res.token, retrieveUser())
      this.props.updateRequestStatus(res.status, res.message)
      this.context.toggleModal(false)
    })
    .catch(({response}) => {
      const errors = !!response.fields ? {...response.fields} : {}
      this.props.updateRequestStatus(response.status, response.message)
      this.setState({ errors })
    })
  }

  _handleChange(e) {
    this.setState({
      formData: {
        ...this.state.formData,
        [e.target.name]: e.target.value
      }
    })
    this._validate(e.target.name, e.target.value)
  }

  _validate(name, value) {
    let formData = {
      ...this.state.formData,
      [name]: value
    }
    const validator = new Validator(formData, EditPassword.validationRules)

    this.setState({
      buttonProps: {
        disabled: !validator.passes()
      }
    })
  }

  render() {
    const formData = this.state.formData
    return (
      <div id="EditPassword" className="EditModal Modal__content">
        <div className="EditModal__header d-flex justify-content-between align-items-center">
          <h1>Cambiar contraseña</h1>
          <span className="material-icons close-button" onClick={() => this.context.toggleModal(false)}>clear</span>
        </div>
        <form onSubmit={this._handleSubmit} className="f-flex EditModal__form">
          <div className="modal-elements-container justify-content-center">
            <Input
              className="current-password"
              icon="https"
              name="current_password"
              errors={this.state.errors.current_password}
              onChange={this._handleChange}
              placeholder="Contraseña actual"
              type="password"
              label="Contraseña actual"
              value={formData.current_password}
              autoFocus
            />
            <Input
              errors={this.state.errors.password}
              icon="https"
              label="Nueva contraseña"
              name="password"
              onChange={this._handleChange}
              placeholder="Nueva contraseña"
              type="password"
              value={formData.password}
            />
            <Input
              errors={this.state.errors.password_confirmation}
              icon="https"
              label="Confirmar contraseña"
              name="password_confirmation"
              onChange={this._handleChange}
              placeholder="Confirmar contraseña"
              type="password"
              value={formData.password_confirmation}
            />
          </div>
          <div className="controls d-flex justify-content-center">
            <Button id="editPasswordButton"
                    type="submit"
                    className="button"
                    size="big"
                    buttonType="danger"
                    {...this.state.buttonProps}>Actualizar contraseña</Button>
          </div>
        </form>
      </div>
    )
  }
}


EditPassword.contextTypes = {
  toggleModal: PropTypes.func.isRequired
}

const mapDispatchToProps = (dispatch) => {
  return {
    updateRequestStatus: (status, message) => dispatch(statusChanged(status, message))
  }
}

export default connect(null, mapDispatchToProps)(EditPassword)



// WEBPACK FOOTER //
// ./src/containers/Dashboard/components/Header/DropDown/EditPassword/index.js